import { format } from "date-fns";

/**
 * Safely format a date value with date-fns, returning `fallback` instead of
 * throwing when the value is null/undefined/empty or produces an Invalid Date.
 * Guards the `format(new Date(apiField || ""), ...)` crash vector that throws
 * RangeError on malformed API date fields. See .claude/rules/web/error-boundaries.md.
 */
export function safeDateFormat(
  value: string | number | Date | null | undefined,
  fmt: string,
  fallback = "—"
): string {
  if (value === null || value === undefined || value === "") return fallback;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  try {
    return format(date, fmt);
  } catch {
    return fallback;
  }
}
